import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a google
 * @param {*} state
 * @param {*} action
 */
export default function googleSearchReducer(state = initialState.googleSearch, action){

    switch(action.type)
    {
        case types.GET_TIMEZONE_REQUEST:
            return {...state,
                dstOffset: null,
                rawOffset: null,
                error: null, isSearching: true};
        case types.GET_TIMEZONE_SUCCESS:
            return {...state,
                    dstOffset: action.data.dstOffset,
                    rawOffset: action.data.rawOffset,
                    error: null, isSearching: false};
        case types.GET_TIMEZONE_ERROR:
            return {...state, error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/googleSearchReducer.js